module.exports = __webpack_public_path__ + "static/2019-publicArt-2-949f231a213fd28d16beaedaff5a946d.jpg";